<div class="item-event" (click)="openEvent(userEvent)">
  <span class="item-event__time" [ngClass]="{ 'item-event__time--isHeader': isHeader }">
    <ng-container *ngIf="userEvent?.allDay; else startEndTimes"> {{ 'user.events.allDay' | translate }} </ng-container>
    <ng-template #startEndTimes>
      {{ userEvent?.startDateTime | date: 'HH:mm' }}
      <ng-container *ngIf="userEvent?.endDateTime"> - {{ userEvent?.endDateTime | date: 'HH:mm' }} </ng-container>
    </ng-template>
  </span>
  <div class="item-event__event-container">
    <span *ngIf="!isHeader" class="odilo-icon extra hide-icon-mobile" aria-hidden="true"> {{ icon }} </span>
    <div class="event-data">
      <span class="event-data__title"> {{ userEvent?.title | translate }} </span>
      <span class="event-data__caption"> {{ userEvent?.details | translate }} </span>
    </div>
  </div>
  <div class="icon-calendar">
    <button class="only-icon icon-not-menu" mat-flat-button appStopPropagation (click)="openCalendarDialog()">
      <span class="odilo-icon" aria-hidden="true">calendar_add</span>
    </button>
  </div>
</div>

<platforms-calendar-dialog #platformsCalendarDialog [platforms]="platforms()"></platforms-calendar-dialog>